import {toBusinessApiDateString} from 'src/jobs/job-schedule-format'

import type {JobAllocation, JobRequirement} from './types'

export function isPastEndDate(
    endDate: string | null | undefined,
    today = toBusinessApiDateString(new Date()),
) {
    return endDate != null && endDate < today
}

export function missingEquipmentCount(job: {
    requirements: JobRequirement[]
    allocations: JobAllocation[]
}): number {
    return job.requirements
        .filter((requirement) => requirement.kind !== 'worker')
        .reduce((missing, requirement) => {
            const assigned =
                Math.max(
                    requirement.assignedQuantity ?? 0,
                    job.allocations.filter((entry) => entry.requirementId === requirement.id)
                        .length,
                ) + (requirement.onSiteQuantity ?? 0)
            return missing + Math.max(0, requirement.quantity - assigned)
        }, 0)
}
